module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.product.specific.called) ? _c('div', [(_vm.product.figures.underlyingPrice.useLast >= _vm.product.derived.nextObservation.strike) ? _c('p', [_vm._v("\n    Bei einem unveränderten Basiswertkurs kommt es zu einer "), (_vm.product.common.maturityDate != _vm.product.derived.nextObservation.date) ? _c('span', [_vm._v("vorzeitigen")]) : _vm._e(), _vm._v("\n    Rückzahlung zum Nennbetrag von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.notional, 'EUR'))
    }
  }), _vm._v("\n    zuzüglich einer Kuponzahlung in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.derived.nextCoupon.coupon))
    }
  }), _vm._v(" p.a.\n    am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.derived.nextCoupon.payDate))
    }
  }), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), (_vm.product.common.maturityDate != _vm.product.derived.nextObservation.date) ? _c('div', [(_vm.product.figures.underlyingPrice.useLast < _vm.product.derived.nextObservation.strike && _vm.product.specific.barrierHit) ? _c('p', [_vm._v("\n      Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen Rückzahlung\n      und es droht am Laufzeitende ein Nennwertverlust. Die nächste Kuponzahlung in\n      Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.derived.nextCoupon.coupon))
    }
  }), _vm._v(" p.a.\n      erfolgt am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.derived.nextCoupon.payDate))
    }
  }), _vm._v(". Die\n      Kursschschwelle von\n      "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.barrier, _vm.added.underlyingQuotedAs))
    }
  }), _vm._v(" wurde\n      bereits berührt.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.product.figures.underlyingPrice.useLast < _vm.product.derived.nextObservation.strike && !_vm.product.specific.barrierHit) ? _c('p', [_vm._v("\n      Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen Rückzahlung des Nennbetrags.\n      Die nächste Kuponzahlung in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.derived.nextCoupon.coupon))
    }
  }), _vm._v(" p.a.\n      erfolgt am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.derived.nextCoupon.payDate))
    }
  }), _vm._v(". Die\n      Kursschschwelle von\n      "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.barrier, _vm.added.underlyingQuotedAs))
    }
  }), _vm._v(" wurde\n      noch nicht berührt.\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product.common.maturityDate == _vm.product.derived.nextObservation.date) ? _c('div', [(_vm.product.figures.underlyingPrice.useLast < _vm.product.derived.nextObservation.strike && _vm.product.specific.barrierHit) ? _c('p', [_vm._v("\n      Bei einem unveränderten Basiswertkurs kommt es zu einer Rückzahlung und es droht am Laufzeitende ein\n      Nennwertverlust. Die nächste Kuponzahlung in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.derived.nextCoupon.coupon))
    }
  }), _vm._v(" p.a.\n      erfolgt am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.derived.nextCoupon.payDate))
    }
  }), _vm._v(". Die\n      Kursschschwelle von\n      "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.barrier, _vm.added.underlyingQuotedAs))
    }
  }), _vm._v(" wurde\n      bereits berührt.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.product.figures.underlyingPrice.useLast < _vm.product.derived.nextObservation.strike && !_vm.product.specific.barrierHit) ? _c('p', [_vm._v("\n      Bei einem unveränderten Basiswertkurs kommt es zu einer Rückzahlung zum Nennbetrag von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.notional, 'EUR'))
    }
  }), _vm._v("\n      zuzüglich einer Kuponzahlung in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.derived.nextCoupon.coupon, 'EUR'))
    }
  }), _vm._v(" p.a.\n      am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.derived.nextCoupon.payDate))
    }
  }), _vm._v(".\n      Die Kursschschwelle von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.barrier, _vm.added.underlyingQuotedAs))
    }
  }), _vm._v(" wurde noch\n      nicht berührt.\n    ")]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3acef4cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factsheet/payback/PaybackFixKupon.vue
// module id = 674
// module chunks = 0